import React, { useState, useEffect } from "react";
import {
    Button,
    Form,
    Image,
    Input,
    Select,
    Space,
    TimePicker,
    Upload,
    notification
} from "antd";
import { AiOutlineRight } from "react-icons/ai";
import { GrUpload } from "react-icons/gr";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import { Divider, Steps } from 'antd';
import CategoryRequest from "../Categories/CategoryRequest";
import SalonRequest from "./SalonRequest";





const getBase64 = (file) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });

const UploadSaloonImage = ({ form, onFinishUploadImage, setLoading, setSaloonImage }) => {

    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState("");
    const [fileList, setFileList] = useState([]);
    console.log(fileList, 'filelist')
    const [saloonImages, setSaloonImagesState] = useState([]);

    const handlePreview = async (file) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }
        setPreviewImage(file.url || file.preview);
        setPreviewOpen(true);
    };

    const handleImageChange = ({ fileList: newFileList }) => setFileList(newFileList);

    const uploadButton = (
        <button type="button" style={{ border: 0, background: "none" }}>
            <GrUpload />
            <div style={{ marginTop: 8 }}>Upload</div>
        </button>
    );

    const imageUpload = (file, name) => {


        setLoading(true)

        const modifiedFile = new File([file], name, { type: file.type });
        let formData = new FormData();

        formData.append("file", modifiedFile);
        formData.append("fileName", name);

        console.log(name, file, 'name')
        SalonRequest
            .uploadImage(formData)
            .then((res) => {

                form.setFieldsValue({
                    categoryImage: res?.data?.uploadDirectory,
                });
                console.log(res)
                const uploadedImagePath = res?.data?.uploadDirectory;
                setSaloonImagesState((prevImages) => {
                    const updatedImages = [...prevImages, uploadedImagePath];
                    setSaloonImage(updatedImages);
                    return updatedImages;
                });


                setLoading(true)
                if (res) {
                    return true;
                } else {
                    return false;
                }
            })
            .catch((e) => {

                setLoading(true)
                notification["error"]({
                    message: "File upload Failed",
                })
            }
            );
    };
    const handleRemove = (file) => {

        setFileList((prevFileList) => prevFileList.filter((item) => item.uid !== file.uid));
        form.resetFields(["categoryImage"]);
        setSaloonImagesState((prevImages) => {
            const updatedImages = prevImages.filter((_, index) => index !== fileList.findIndex((f) => f.uid === file.uid));
            setSaloonImage(updatedImages);
            return updatedImages;
        });
    };

    // const props = {
    //     name: "file",
    //     multiple: true,
    //     beforeUpload: (file) => {
    //         imageUpload(file, file.name);
    //         return false;
    //     },
    //     onRemove: handleRemove,
    // };


      const props = {
        name: "file",
        multiple: false,
        accept : "image/*",
        beforeUpload: (file) => {
          const isImage = file.type.startsWith("image/");
          if(!isImage){
            notification.error({
              message : "Invalid file type",
              description : "Only image files are allowed (jpg, png, jpeg, webp)",
            });
            return Upload.LIST_IGNORE; 
          }
          imageUpload(file, file.name);
          return false;
        },
        onRemove() {
          setFileList([]);
        },
      };
      

    return (
        <>
            <section>
                <div className="Create-Category">

                    <Form
                        layout="vertical"
                        className="subscription-form"
                        form={form}
                        onFinish={onFinishUploadImage}
                    >


                        <div className="upload-Img">
                            <Form.Item
                                rules={[{ required: true, message: "Please upload the salon images" }]}
                                label="Upload Salon Images"
                                name="categoryImage"
                                className="subscription-plan"
                            >
                                <Upload
                                    {...props}
                                    maxCount={10}
                                    listType="picture-card"
                                    fileList={fileList}
                                    onPreview={handlePreview}
                                    onChange={handleImageChange}
                                >
                                    {fileList.length >= 8 ? null : uploadButton}
                                </Upload>
                                {previewImage && (
                                    <Image
                                        wrapperStyle={{
                                            display: "none",
                                        }}
                                        preview={{
                                            visible: previewOpen,
                                            onVisibleChange: (visible) => setPreviewOpen(visible),
                                        }}
                                        src={previewImage}
                                    />
                                )}
                            </Form.Item>
                        </div>
                        <div className="steps-action">
                            <Button type="primary" htmlType="submit">
                                Next
                            </Button>
                        </div>

                    </Form>
                </div>
            </section>
        </>
    );
};

export default UploadSaloonImage;
